import {
  HEIGHT_UNIT,
  formatHeight,
  fromFeetAndInches,
  parseHeightInput,
} from '@wlb/shared/utils/heightUtils';

export const DEFAULT_HEIGHT_METRES = 1.7272;
export const DEFAULT_HEIGHT_UNIT = HEIGHT_UNIT.FEET;

export const heightScaleValue = (metres: number, unit: string): number =>
  unit === HEIGHT_UNIT.FEET
    ? Math.round((metres * 100) / 2.54)
    : Number(metres.toFixed(2));

export const heightMetresFromScale = (value: number, unit: string): number => {
  if (unit !== HEIGHT_UNIT.FEET) return Number(value.toFixed(2));

  const feet = Math.floor(value / 12);
  const inches = value % 12;
  return fromFeetAndInches(feet, inches);
};

export const formatOnboardingHeight = (
  metres: number,
  unit: string,
): string => formatHeight(
  metres,
  unit === HEIGHT_UNIT.FEET ? 'ft' : 'm',
);

export const parseOnboardingHeight = (
  input: string,
  unit: string,
): number | null => parseHeightInput(input, unit);
